import React from "react";
import { ReactComponent as IconEye } from "@assets/Icons/Icon_Eye.svg";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { withFallback } from "kontrolEdge/helpers/formattersShappedData";

export interface SupportTicket {
	id: string | number;
	type: string;
	subject: string;
	priority: number;
	reporterEmail: string;
	reporter: string;
	service_id: string;
	status: {
		label: string;
		label_for_customers?: string;
		name?: string;
	};
	customer?: {
		name: string;
		id: number;
		chargebeeCustomerId: string
	};
	key?: string | number;
}


export const getStatusText = (s: SupportTicket["status"]) =>
	withFallback(typeof s === "string" ? s : s?.label || s?.name);

// A function that returns the columns based on the global product value.
export const getTicketColumns = (
	globalProduct: string|null
): GenericTableColumn<SupportTicket>[] => [
	{
		header: "Type",
		renderCell: (row) => withFallback(row.type),
		sortable: true,
		sortAccessor: (row) => row.type ?? "",  
	},
	{
		header: "Ticket Number",
		renderCell: (row) =>
			withFallback(globalProduct === "CTX Reflector" ? row.id : row.key),
		},
	{
		header: "Title",
		renderCell: (row) => withFallback(row.subject),
	},
	{
		header: "Reporter",
		renderCell: (row) =>
			row.reporter || row.reporterEmail ? (
			<div className="flex flex-col">
			<span className="font-medium">{withFallback(row.reporter)}</span>
			<span className="text-xs text-gray-500">{withFallback(row.reporterEmail)}</span>
			</div>
			) : (
			"—"
			),
	},
	{
		header: "Service ID",
		renderCell: (row) => withFallback(row.service_id),
	},
	{
		header: "Status",
		renderCell: (row) => getStatusText(row.status),
		sortable: true,
		sortAccessor: (row) =>
			typeof row.status === "string" ? row.status || "" : (row.status?.label || row.status?.name || ""),
		},
	{
		header: "Priority",
		renderCell: (row) => withFallback(row.priority),
		sortable: true,
		sortAccessor: (row) => Number(row.priority),
	},
	{
		header: "Details",
		renderCell: (row) => (
			<button
				onClick={() => alert(`Detalles del ticket: ${row.id}`)}
				className="
          flex items-center justify-center
          border border-semantic-border-secondary
          rounded
          text-semantic-text-secondary
          hover:bg-semantic-state-active
          w-10 h-10
        "
			>
				<IconEye className="w-6 h-6" />
			</button>
		),
	},
];
